import { useQuery } from '@tanstack/react-query';
import type { ScopeUnitDto } from '@repo/shared/dtos/analytics/ScopeFilterDto';
import { API_ENDPOINTS, QUERY_KEYS, CACHE_CONFIG, RETRY_CONFIG } from '../constants/endpoints';

// Units the current user can filter analytics by — shared by the filter bar and the export panel.
export function useFilterUnits(enabled: boolean) {
  return useQuery<ScopeUnitDto[]>({
    queryKey: QUERY_KEYS.FILTERS_UNITS,
    queryFn: async () => {
      const response = await fetch(API_ENDPOINTS.SCOPE_FILTER, { credentials: 'include' });
      if (!response.ok) throw new Error('Failed to fetch units');
      return response.json();
    },
    enabled,
    staleTime: CACHE_CONFIG.UNITS.staleTime,
    gcTime: CACHE_CONFIG.UNITS.gcTime,
    retry: RETRY_CONFIG.shouldRetry,
    retryDelay: RETRY_CONFIG.retryDelay,
  });
}
